import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import CookieBanner from './components/shared/CookieBanner';
import EricaLandingPage from './pages/EricaLandingPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import CompanyPage from './pages/CompanyPage';
import Footer from './components/layout/Footer';

function App() {
  return (
    <Router>
      <main className="min-h-screen bg-white">
        <Navbar />
        <Routes>
          <Route path="/" element={<EricaLandingPage />} />
          <Route path="/company" element={<CompanyPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <CookieBanner />
      </main>
    </Router>
  );
}

export default App;
